<template>
<v-card class="panelBlock ma-2 conduct-terms" v-if="shareYourIdeasOptions && shareYourIdeasOptions.length">
    <v-layout row wrap >
        <v-flex xs12 tag="h2">{{myToolsConstants.SHARE_YOUR_IDEAS}}</v-flex>
        <v-flex class="resources inner-scrollbar">
                <v-flex class="resources__list-items" v-for="(heading, index) in shareYourIdeasOptions" :key="heading.name">
                    <span :id="`shareYourIdeas_${index}`">
                        <a class="urls" :href="heading.url" :target="linkTarget" :data-qe-id="'shareYourIdeas_'+index">{{heading.name}} </a>
                    </span>                   
                </v-flex>
            </v-flex>        
    </v-layout>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { storeGetters } from '../../store/storeGetters.constant';
import { myToolsConstants } from "./mytools.constant.js";

export default {
    name: "ShareYourIdeas",
    data: () => ({
        myToolsConstants,
        menuPanel: [],        
    }),
    props: {
        showHideTools: {
            type: Function,
        },
     },    
    components: {},
    methods: {               
        none() {
            this.subMenuPanel = -1;
            this.menuPanel = -1;
        },    
    },
  computed: {
        ...mapGetters({
            shareYourIdeasLinks: `tools/${storeGetters.shareYourIdeasLinks}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            profileInformation: `myAccount/${storeGetters.profileInformation}`,
        }),
        linkTarget() {
            return this.isMobileAppBrowser ? '_self' : '_blank';
        },
        shareYourIdeasOptions() {
              let options = [];
              if (this.shareYourIdeasLinks) {
                options = this.canViewIdeasIntoActionLink
                    ? this.shareYourIdeasLinks
                    : this.shareYourIdeasLinks.filter(link => link.name !== myToolsConstants.IDEAS_INTO_ACTION_LINK);
              }
              return options;
        },
        canViewIdeasIntoActionLink() {
          return this.profileInformation && this.profileInformation.recordTypeName
              && myToolsConstants.rolesWithAccessToIdeasIntoAction.includes(this.profileInformation.recordTypeName);
        },
    },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

    .resources {
    border: none;

    .heading {
        color: $ypo-cta;
        font-size: 14px;
        font-weight: bold;
        line-height: 18px;
    }

    .urls {
        text-decoration: none;
        transition: 0.3s;
        font-size: 14px;
        font-weight: 500;
        color: $ypo-cta;
        margin-top: 15px;
        display: inline-block;
        margin-left: 20px;

        &:hover {
            text-decoration: underline;
            color: $ypo_blue;
        }
    }

    &__list {
        &:first-child {
            padding-top: 20px;
        }
    }
}
</style>
